import { Reducer } from 'redux';
import { SharedActionTypes } from '../shared/types';
import { arrayUnique } from './../../utils/sharedHelpers';
import { Season, SeasonActionTypes, SeasonState } from './types';
import * as moment from 'moment';

const initialState: SeasonState = {
  data: {
    byId: {},
    allIds: [],
    bySectionTitle: {}
  },
  errors: undefined,
  loading: false
};

const reducer: Reducer<SeasonState> = (state = initialState, action) => {
  switch (action.type) {
    case SeasonActionTypes.FETCH_REQUEST: {
      return { ...state, loading: true };
    }
    case SeasonActionTypes.UPDATE_SUCCESS: {
      const { data } = action.payload;

      const byId = { ...state.data.byId };

      const id = data.id;

      byId[id] = { ...byId[id], ...data };

      return {
        ...state,
        data: {
          ...state.data,
          byId: { ...state.data.byId, ...byId }
        },
        loading: false
      };
    }
    case SeasonActionTypes.CREATE_SUCCESS: {
      const { data, sectionTitle } = action.payload;

      const byId = { ...state.data.byId };

      const id = data.id;

      byId[id] = { ...byId[id], ...data };

      const bySectionTitle = { ...state.data.bySectionTitle };
      if (!bySectionTitle[sectionTitle]) {
        bySectionTitle[sectionTitle] = [];
      }
      bySectionTitle[sectionTitle].push(id);

      return {
        ...state,
        data: {
          ...state.data,
          byId,
          allIds: [...state.data.allIds.concat(id)],
          bySectionTitle
        },
        loading: false
      };
    }
    case SeasonActionTypes.DELETE_SUCCESS: {
      const { data, sectionTitle } = action.payload;

      const byId = { ...state.data.byId };

      delete byId[data.id];

      const allIds = [...state.data.allIds];
      allIds.splice(allIds.indexOf(data.id), 1);

      const bySectionTitle = { ...state.data.bySectionTitle };

      if (bySectionTitle[sectionTitle]) {
        bySectionTitle[sectionTitle].splice(bySectionTitle[sectionTitle].indexOf(data.id), 1);
      }

      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          byId,
          allIds,
          bySectionTitle
        }
      };
    }
    case SeasonActionTypes.FETCH_SUCCESS: {
      const seasons = action.payload.data;
      const sectionTitle = action.payload.sectionTitle;

      const byId = {};
      const allIds: number[] = [];

      seasons.forEach((el: Season) => {
        byId[el.id] = el;
        allIds.push(el.id);
      });

      allIds.sort();

      const bySectionTitle = {};
      bySectionTitle[sectionTitle] = allIds;

      return {
        ...state,
        data: {
          ...state.data,
          byId: { ...state.data.byId, ...byId },
          allIds: arrayUnique(state.data.allIds.concat(allIds)),
          bySectionTitle: { ...state.data.bySectionTitle, ...bySectionTitle }
        },
        loading: false
      };
    }
    case SeasonActionTypes.FETCH_ERROR: {
      return { ...state, loading: false, errors: action.payload };
    }
    case SeasonActionTypes.TOGGLE_SEASON: {
      const id = action.payload.id;
      const sectionTitle = action.payload.sectionTitle;

      const ids = state.data.bySectionTitle[sectionTitle];

      const newById = {
        [id]: {
          ...state.data.byId[id],
          selected: true
        }
      };

      state.data.allIds.forEach((eID: number) => {
        if (eID !== id) {
          newById[eID] = { ...state.data.byId[eID] };
          if (ids.find(i => i === eID)) {
            newById[eID].selected = false;
          }
        }
      });

      return {
        ...state,
        data: {
          ...state.data,
          byId: { ...state.data.byId, ...newById }
        }
      };
    }
    case SeasonActionTypes.CHECK_CURRENT_SEASON: {
      const sectionTitle: string = action.payload;

      const ids = state.data.bySectionTitle[sectionTitle];

      if (
        ids &&
        ids.length > 0 &&
        !ids.some(nr => {
          const el = state.data.byId[nr];
          return el.selected;
        })
      ) {
        const current = moment();

        let selectedId = ids.find(i => {
          const season = state.data.byId[i];

          return (
            current.isSameOrAfter(season.startdate, 'd') &&
            current.isSameOrBefore(season.enddate, 'd')
          );
        });

        if (selectedId === undefined) {
          selectedId = ids[0];
        }

        const newById = {
          [selectedId]: {
            ...state.data.byId[selectedId],
            selected: true
          }
        };

        state.data.allIds.forEach((eID: number) => {
          if (eID !== selectedId) {
            newById[eID] = { ...state.data.byId[eID] };
            if (ids.find(id => eID === id)) {
              newById[eID].selected = false;
            }
          }
        });

        return {
          ...state,
          data: {
            ...state.data,
            byId: { ...state.data.byId, ...newById }
          }
        };
      }
      return state;
    }
    case SharedActionTypes.RESET: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export { reducer as SeasonReducer };



// WEBPACK FOOTER //
// ./src/store/season/reducer.ts